import { AddOnPricingDetailArray } from './add.on.pricing.detail';
import { PaymentMethodTypes, BillingCycleTypes } from './invoice';

export enum LicenseStatusTypes {
    Open = 0,
    Registered = 1,
    Cancelled = 2,
    CancelledOpen = 3,
    Disabled = 4,
    Transfered = 5,
    Terminated = 99,
    DoesNotExist = 100,
    Active = 1000  //Applicable to memberships
}

export enum LicensePackageTypes {
    PoolStudio = 101,
    VizTerra = 103,
    VIP3D = 105,
    Student = 106,
    Unknown = 999
}

export enum LiveHubConnectionStatuses {
    NotConnected = 0,
    Connected = 1,
    Unknown = 2
}

export interface ILicense {
    ID: number;
    Key: string;
    Status: LicenseStatusTypes;
    PackageType: LicensePackageTypes;
    ProductName: string;
    DateTimeCreated: Date;
    TransferDisabled: boolean;
    TransferDisabledReason: string;
    TransferLimitMax: number;
    TransferLimitInTimeMinutes: number;
    SoftwareVersion: string;
    RegistrationKey: string;
    TargetID: string;
    HardwareSerial: string;
    MacAddress: string;
    MachineNameId: string;
    VideoCard: string;
    SoftwareVersionLock: string;
    SoftwareVersionLockReason: string;
    RegistrationIP: string;
    LastLoginIP: string;
    DateTimeUpdated: Date;
    MemberID: number;
    ServiceID: number;
    ProductID: number;
    SettingsID: number;
    MemberName: string;
    NextBillingDate: Date;
    CompanyName: string;
    StatusDisabledReason: string;
    HasNotes: boolean;
    PaymentMethod: PaymentMethodTypes;
    BillingCycle: BillingCycleTypes;
    AssignedPoolStudioSettingsGroup: number;
    OwnedByDesigner: boolean;
    IsAssigned: boolean;
    Yard: boolean;
    YardServiceID: number;
    YardDeviceID: number;
    YardVersion: string;
    YardLastLogin: Date;
    DontSendManualCancellationEmail: boolean;
    AlwaysImportStatistics: boolean;
    CancellationReason: string;
    TerminationDate: Date;
    ProductRecurringAmount: number;
    YardRecurringAmount: number;

    ParentID?: number;
    ParentName: string;

    Transfer_To_MemberID: number;
    Transfer_To_Member: string;
    Transfer_From_MemberID: number;
    Transfer_From_Member: string;
    DateTimeTransferedTo: Date;

    IsInGracePeriod: boolean;

    LiveHubConnectionStatus: LiveHubConnectionStatuses;
    LiveHubDateTimeConnectionStarted: Date;
    LiveHubDateTimeConnectionStopped: Date;

    LiveHubVersion: string;
    DragonrollVersion: string;

    FileAccessPermissionGranted: boolean;
    FileAccessPermissionExpires: Date;

    OverrideUpdaterClientSettings_ID?: number;

    VideoCardBenchmark: number;

	TOSDetectiveWhiteListExpiration: Date;
	
    UpdateVersionForceGroupID?: number;
    UpdaterV3VersionForceGroupID?: number;
    
    TransferLimitPCs: number;
    
    PreventV3Install: boolean;

    IgnoreHardwareCheck: boolean;

    DeviceID: string;
    ProcessorID : string;
    HDSerial : string;
    MotherBoardSerial : string;
    SystemUUID : string;

    TOSWindow: boolean;
    TOSWindowContinueUntilDate: Date;

    AddOnPricingDetails: AddOnPricingDetailArray; 

}


export class LicenseArray extends Array<License>  {

    constructor(...items: License[]) {
        super(...items);
        Object.setPrototypeOf(this, LicenseArray.prototype);
    }

}


export class License implements ILicense {
    ID: number;
    Key: string;
    Status: LicenseStatusTypes;
    PackageType: LicensePackageTypes;
    ProductName: string;
    DateTimeCreated: Date;
    TransferDisabled: boolean;
    TransferDisabledReason: string;
    TransferLimitMax: number;
    TransferLimitInTimeMinutes: number;
    SoftwareVersion: string;
    RegistrationKey: string;
    TargetID: string;
    HardwareSerial: string;
    MacAddress: string;
    MachineNameId: string;
    VideoCard: string;
    SoftwareVersionLock: string;
    SoftwareVersionLockReason: string;
    RegistrationIP: string;
    LastLoginIP: string;
    DateTimeUpdated: Date;
    MemberID: number;
    ServiceID: number;
    ProductID: number;
    MemberName: string;
    NextBillingDate: Date;
    CompanyName: string;
    ProductRecurringAmount: number;
    YardRecurringAmount: number;
    PaymentMethod: PaymentMethodTypes;
    BillingCycle: BillingCycleTypes;
    StatusDisabledReason: string;
    HasNotes: boolean;
    SettingsID: number;
    AssignedPoolStudioSettingsGroup: number;
    OwnedByDesigner: boolean;
    IsAssigned: boolean;
    Yard: boolean;
    YardServiceID: number;
    YardDeviceID: number;
    YardVersion: string;
    YardLastLogin: Date;
    DontSendManualCancellationEmail: boolean;
    AlwaysImportStatistics: boolean;
    CancellationReason: string;
    TerminationDate: Date;

    ReportedCPUBenchmark?: number;
    ReportedGPUBenchmark?: number;

    ParentID?: number;
    ParentName: string;
    SalesRepresentativeID: number;

    Transfer_To_MemberID: number;
    Transfer_To_Member: string;
    Transfer_From_MemberID: number;
    Transfer_From_Member: string;
    DateTimeTransferedTo: Date;

    IsInGracePeriod: boolean;

    LiveHubConnectionStatus: LiveHubConnectionStatuses;
    LiveHubDateTimeConnectionStarted: Date;
    LiveHubDateTimeConnectionStopped: Date;

    LiveHubVersion: string;
    DragonrollVersion: string;

    FileAccessPermissionGranted: boolean;
    FileAccessPermissionExpires: Date;

    OverrideUpdaterClientSettings_ID?: number;

    VideoCardBenchmark: number;

    TOSDetectiveWhiteListExpiration: Date;

    UpdateVersionForceGroupID?: number;
    UpdaterV3VersionForceGroupID?: number;

    TransferLimitPCs: number;
    
    PreventV3Install: boolean;

    IgnoreHardwareCheck: boolean;

    DeviceID: string;
    ProcessorID : string;
    HDSerial : string;
    MotherBoardSerial : string;
    SystemUUID : string;

    TOSWindow: boolean;
    TOSWindowContinueUntilDate: Date;

    AddOnPricingDetails: AddOnPricingDetailArray;

    public static FixDates(license: License) {
        license.DateTimeCreated = new Date(license.DateTimeCreated);
        license.DateTimeUpdated = new Date(license.DateTimeUpdated);
        license.NextBillingDate = new Date(license.NextBillingDate);
        license.DateTimeTransferedTo = new Date(license.DateTimeTransferedTo);
        license.YardLastLogin = new Date(license.YardLastLogin);
        license.TerminationDate = new Date(license.TerminationDate);
        license.LiveHubDateTimeConnectionStarted = new Date(license.LiveHubDateTimeConnectionStarted);
        license.LiveHubDateTimeConnectionStopped = new Date(license.LiveHubDateTimeConnectionStopped);
        license.TOSDetectiveWhiteListExpiration = new Date(license.TOSDetectiveWhiteListExpiration);
        license.FileAccessPermissionExpires = new Date(license.FileAccessPermissionExpires);
        if (license.TOSWindowContinueUntilDate) {
            license.TOSWindowContinueUntilDate = new Date(license.TOSWindowContinueUntilDate);
        }
    }


}
